import React, {Component} from 'react'
import {connect} from 'react-redux'
import WithAjax from '../common/helpers/WithAjax'
import {validateField} from '../../actions/helpers/validation'
import {setJumbotronTitle} from '../../actions/common'
import {
  fetchUserEditDataSuccess,
  validateUserEditField,
  submitUserEditFields,
  clearUserEditFields } from '../../actions/pages/user-page'
import InputField from '../common/form/InputField'
import CheckboxField from '../common/form/CheckboxField'
import Alert from '../../ui-elements/alerts/Alert'
import EditForm from '../../pages/EditForm'
import Role from './Role'

class UserEditForm extends Component {
  constructor() {
    super()

    this.state = {
      formVisible: false,
      selectedRoles: [],
      rolesItems: [],
      isRoles: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleManageRole = this.handleManageRole.bind(this);

    this.userBaseUrl = 'adminusers/'

  }


  componentDidMount() {

    let id = parseInt(this.props.match.params.id, 10);

    this.props.clearUserEditFields();

    if (Number.isInteger(id)) {
      let url = this.userBaseUrl + id;

      this.props.ajax.get(url, true, (data) => {

        this.props.fetchUserEditDataSuccess(data);
        this.props.setJumbotronTitle('Edit user');

        this.setState({formVisible: true})
        this.setState({selectedRoles: data.Roles.SelectedValue});
        this.setState({rolesItems: data.Roles.Items});
      })
    }
    else {
      this.props.setJumbotronTitle('Create');
      //get user 0
      let url = this.userBaseUrl + '0'
      this.props.ajax.get(url, true, (data) => {

        this.props.fetchUserEditDataSuccess(data);

        this.setState({formVisible: true})
        this.setState({selectedRoles: ''});
        this.setState({rolesItems: data.Roles.Items});
      })
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    let validatedFields = this.props.fields.map(field => validateField(field))

    let isValid =
        validatedFields.filter(field => field.errors.length > 0).length > 0
          ? false
          : true

    this.props.submitUserEditFields(validatedFields);

    if (!isValid){
      return;
    }

    let data = {}
    this.props.fields.forEach((field) => {
      data[field.name] = field.value;
    })

    let id = parseInt(this.props.match.params.id, 10);

    if(!this.state.selectedRoles){
      this.setState({
        errorMsg: `No role has been selected.`
      })
      return false;
    }

    let selectedRolesArr = this.state.selectedRoles.split(",");
    if(selectedRolesArr[0] == ''){
      selectedRolesArr.shift();
    }
    data.Roles = selectedRolesArr;

    if (Number.isInteger(id)) {
      this.props.ajax.put(
        this.userBaseUrl + id,
        JSON.stringify(data),
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        },
        (response) => {
          if (response.Status === 'OK') {
            this.props.history.push('/users');
          }
          else{
            this.setState({
              errorMsg: response.Errors[0].Messages[0]
            })
          }
        })
    }
    else{
      this.props.ajax.post(
        this.userBaseUrl,
        JSON.stringify(data),
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        },
        (response) => {
          if (response.LastAddedId) {
            this.props.history.push('/users');
          }
          else{
            this.setState({
              errorMsg: response.Errors[0].Messages[0]
            })
          }
        })
    }
  }

  handleManageRole(idRole){
    let selectedRolesArr = this.state.selectedRoles.split(",");
    if(selectedRolesArr.includes(idRole)){
      var index = selectedRolesArr.indexOf(idRole);
      if (index > -1) {
        selectedRolesArr.splice(index, 1);
        let stateRoles = selectedRolesArr.toString();
        this.setState({selectedRoles: stateRoles});
      }
    }else{
      selectedRolesArr.push(idRole);
      let stateRoles = selectedRolesArr.toString();
      this.setState({selectedRoles: stateRoles});
    }
  }

  isSelectedRole(role){
    let selectedRolesArr = this.state.selectedRoles.split(",");
    if(selectedRolesArr.includes(role.value)){
      return true;
    }
    return false;
  }

  render() {
    let fields = this.props.fields;

    if (!this.state.formVisible){
      return (
        <div></div>
      );
    }

    return (
      <EditForm
        title="Edit user"
        description="">
        <div className="row">
          {this.state.errorMsg &&
            <div className="col-md-12">
              <Alert className="alert alert-danger alert-outline">
                {this.state.errorMsg}
              </Alert>
            </div>
          }
          <div className="col-md-6">
            {fields[2] && <InputField field={fields[2]} validate={this.props.validateUserEditField} />}
          </div>
          <div className="col-md-6">
            {fields[3] && <InputField field={fields[3]} validate={this.props.validateUserEditField} />}
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            {fields[0] && <InputField field={fields[0]} validate={this.props.validateUserEditField} />}
          </div>
          <div className="col-md-6">
            {fields[4] && <InputField field={fields[4]} validate={this.props.validateUserEditField} />}
          </div>
        </div>
        {fields[1] && <CheckboxField field={fields[1]} validate={this.props.validateUserEditField} />}

        Roles
        <br/>
        {!this.state.selectedRoles && <span style={{color: "#d32f2f"}}>At least one role is required</span>}
        <div className="row">
        {fields &&
            this.state.rolesItems.map((role, id) => {
              return <Role handleManageRole={this.handleManageRole}
               role={role} checked={this.isSelectedRole(role)}
               key={id}
               />
            })}
        </div>

        {fields && (
          <div className="form-group">
            <button
              className="btn btn-primary btn-rounded"
              type="submit"
              onClick={this.handleSubmit}>
              Save
            </button>
          </div>
        )}
      </EditForm>

    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  fields: state.userEditForm.fields,
  isLoading: state.common.isLoading
})
const mapDispatchToProps = dispatch => ({
  fetchUserEditDataSuccess: (editData) => dispatch(fetchUserEditDataSuccess(editData)),
  submitUserEditFields: fields => dispatch(submitUserEditFields(fields)),
  validateUserEditField: (value, field) => dispatch(validateUserEditField(value, field)),
  clearUserEditFields: () => dispatch(clearUserEditFields()),
  setJumbotronTitle: title => dispatch(setJumbotronTitle(title))
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(UserEditForm))
